import { useMemo } from 'react';

export function parseStoryblokContent(data) {
  return useMemo(() => {
    return JSON.parse(data.content);
  }, [data]);
}
